import FolderImport from './FolderImport';
import ToolkitImport from './ToolkitImport';
import ProjectImport from './ProjectImport';
import AgentImport from './AgentImport';

type ImportUploadSubComponents = {
  FolderImport: typeof FolderImport;
  ToolkitImport: typeof ToolkitImport;
  ProjectImport: typeof ProjectImport;
  AgentImport: typeof AgentImport;
};

const ImportUpload: ImportUploadSubComponents = () => null;

ImportUpload.FolderImport = FolderImport;
ImportUpload.ToolkitImport = ToolkitImport;
ImportUpload.ProjectImport = ProjectImport;
ImportUpload.AgentImport = AgentImport;

export default ImportUpload;
